import { REGISTER_PROJECT, REGISTER_TABLE,CHANGE_LANG } from "./types";

export const registerProject = (project) => (dispatch) => {
  const host = window.location.hostname || '';
  const port = window.location.port || '';
  const isLocalhost = ['localhost', '127.0.0.1', '0.0.0.0'].includes(host) || !!port;
  let baseHref = isLocalhost ? 'http://food.smartorder.company/' : `/project/${project}/`;

  if (localStorage){
    localStorage.setItem('project', project);
  }
  dispatch({type: REGISTER_PROJECT, payload: {project, baseHref} });
}

export const registerTable = (table) => (dispatch) => {
  dispatch({type: REGISTER_TABLE, payload: {table} });
}

export const changeLang = (lang) => (dispatch) => {
  dispatch({type: CHANGE_LANG, payload: {lang} });
}



